import { Component, Input } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { AppConfigService } from '@markant-platform/shared/data-access';
import { RouteConfig } from '../header/header.component';
import { UpgradeSuggestedStoragePrefix } from '@markant-platform/cartridge/model';
import { removeStorageKeysStartingWith } from '@markant-platform/shared/util-helpers';

@Component({
  selector: 'markant-platform-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
})
export class MobileMenuComponent {
  @Input() routes: RouteConfig[] = [];
  showPopover = false;

  constructor(private readonly authService: AuthService) {}

  togglePopover(): void {
    this.showPopover = !this.showPopover;
  }

  closePopover(): void {
    this.showPopover = false;
  }

  logout(): void {
    this.authService.logout({
      logoutParams: {
        returnTo: AppConfigService.appConfiguration.logoutPageUrl,
      },
    });
    removeStorageKeysStartingWith(UpgradeSuggestedStoragePrefix);
  }
}
